import { useQuery } from "react-query";
import { useFetch } from "../../contexts/FetchProvider";
import { CHECKLIST_URL } from "../../constants/urlConstant";

const useGetChecklistInfo = (id) => {
    const { authRequest } = useFetch();
    return useQuery(
        ["checklist-info", id],
        async () => {
            const response = await authRequest.get(`${CHECKLIST_URL}${id}`);
            return response.data;
        },
        {
            refetchOnWindowFocus: false,
        }
    );
};
// subcategory title with avg
const calculateSubcategory = (i) => {
    let questionAnsValue = []
    i.questions.forEach((item) => {
        const store = [item].map((partialSum) => partialSum.answer_value).filter((partialSum) => partialSum !== 0);
        if(store.length > 0) {
            questionAnsValue.push(store[0])
        }
    })

    const totalSum = questionAnsValue.reduce((accumulator, current) => accumulator + current, 0)
    const avg = questionAnsValue.length > 0 ? parseFloat((totalSum / questionAnsValue.length).toFixed(1)) : "N/A"
    return {
        id: i.id,
        title: i.title,
        avg: avg
    };
}
const useGetChecklistSectionData = () => {
    const { authRequest } = useFetch();
    const id = JSON.parse(localStorage.getItem('checklist_id'))
    const category = JSON.parse(localStorage.getItem('checklist_category'))
    return useQuery(
        ["checklist-section-info", id],
        async () => {
            let questionAnsValue = []
            let subcategoryArray = []
            let title, score;
            const response = await authRequest.get(`${CHECKLIST_URL}${id}`);
            const result = response?.data.categories?.filter((data) => data.id === parseInt(category))
            result[0]?.sections?.forEach((i) => {
                i.questions.forEach((item) => {
                    const store = [item].map((partialSum) => partialSum.answer_value);
                    questionAnsValue.push(store[0])

                })
                const output = calculateSubcategory(i)
                subcategoryArray.push(output)
            });
            title = result[0]?.title
            score = result[0]?.score
            return { title, score, subcategoryArray }
        },
        {
            refetchOnWindowFocus: false,
        }
    );
};

const useGetSubcategoryQuestionData = (id, category, section) => {
    const { authRequest } = useFetch();
    return useQuery(
        ["checklist-subcategory-info", id],
        async () => {
            let title, questions;
            const response = await authRequest.get(`${CHECKLIST_URL}${id}`)
            const result = response?.data?.categories?.filter((data) => data.id === parseInt(category))

            const question = result[0].sections.filter(data => data.id === parseInt(section))
            let questionAnsValue = []
            question[0].questions.forEach((item) => {
                const store = [item]?.map((partialSum) => partialSum.answer_value);
                if (store[0] > 0) {
                    questionAnsValue.push(store[0])
                }
            });
            const totalSum = questionAnsValue?.reduce((accumulator, current) => accumulator + current, 0)
            const avg = questionAnsValue.length === 0 ? "N/A" : parseFloat((totalSum / questionAnsValue?.length).toFixed(1))
            title = question[0]?.title
            questions = question[0]?.questions
            return { avg, title, questions };
        },
        {
            refetchOnWindowFocus: false,
        }
    );
};
export { useGetChecklistInfo, useGetChecklistSectionData, useGetSubcategoryQuestionData }
